module.exports = __webpack_public_path__ + "static/media/ruler.a930ac21.svg";